"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGuardGroupSerializer = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const errors_1 = require("../errors");
const constants_1 = require("../constants");
const guardSet_1 = require("./guardSet");
function getGuardGroupSerializer(context, program) {
    return (0, serializers_1.struct)([
        [
            'label',
            (0, serializers_1.mapSerializer)((0, serializers_1.string)({ size: constants_1.CANDY_GUARD_LABEL_SIZE }), (label) => {
                if (label.length > constants_1.CANDY_GUARD_LABEL_SIZE) {
                    throw new errors_1.GuardGroupLabelTooLongError(label);
                }
                return label;
            }),
        ],
        ['guards', (0, guardSet_1.getGuardSetSerializer)(context, program)],
    ], { description: 'GuardGroup' });
}
exports.getGuardGroupSerializer = getGuardGroupSerializer;
//# sourceMappingURL=guardGroup.js.map